export default __webpack_public_path__ + "static/media/esi-logo.b848ec81.svg";